module.exports = __webpack_public_path__ + "img/QRcode.4d96ddb5.png";